<template>
  <el-dialog
    title="申请阅卷"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <div class="review-dialog">
      <div class="dialog-content">
        <div class="dialog-title">请确认申请阅卷，确认后请耐心等待复议机关审批。</div>
        <div class="form-item">
          <div class="form-label">
            <span class="required">*</span>
            <span class="label">请填写需要查阅内容，申请理由等</span>
          </div>
          <div class="textarea-wrapper">
            <el-input
              v-model="content"
              type="textarea"
              :rows="8"
              :maxlength="maxLength"
              placeholder=""
              @input="onContentInput"
            ></el-input>
            <div class="char-count">{{ contentLength }}/{{ maxLength }}字</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@api/api'

export default {
  name: 'ReviewApplication',
  props: {
    caseOrderNo: {
      type: String,
      default: ''
    },
    maxLength: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      dialogVisible: false,
      content: '',
      contentLength: 0
    }
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true
    },
    
    // 输入内容变化
    onContentInput() {
      this.contentLength = this.content.length
    },
    
    // 取消按钮
    onCancel() {
      this.content = ''
      this.contentLength = 0
      this.dialogVisible = false
    },
    
    // 确定按钮
    async onConfirm() {
      // 验证必填
      if (!this.content || !this.content.trim()) {
        this.$message.warning('请填写需要查阅内容,申请理由等')
        return
      }
      
      // 验证案件流水号
      if (!this.caseOrderNo) {
        this.$message.warning('案件流水号不能为空')
        return
      }
      
      try {
        const loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        // 调用接口提交申请
        const response = await Api.submitReviewApply({
          caseOrderNo: this.caseOrderNo,
          applyReason: this.content.trim()
        })
        
        loading.close()
        
        if (response.data.code == 0) {
          this.$message.success('申请阅卷成功')
          
          // 触发确认事件
          this.$emit('confirm', {
            content: this.content.trim()
          })
          
          // 重置表单
          this.content = ''
          this.contentLength = 0
          this.dialogVisible = false
        } else {
          this.$message.error(response.data.msg || '申请失败')
        }
      } catch (error) {
        console.error('申请阅卷失败', error)
        this.$message.error('申请失败，请重试')
      }
    },
    
    // 关闭弹窗
    onClose() {
      this.content = ''
      this.contentLength = 0
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        // 关闭时重置表单
        this.content = ''
        this.contentLength = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.review-dialog {
  .dialog-content {
    padding: 20px 0;
  }

  .dialog-title {
    font-size: 14px;
    color: #333;
    line-height: 24px;
    margin-bottom: 20px;
    text-align: left;
  }

  .form-item {
    width: 100%;
  }

  .form-label {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .required {
    color: #ff4d4f;
    margin-right: 4px;
  }

  .label {
    color: #2D7DFB;
  }

  .textarea-wrapper {
    position: relative;
    width: 100%;
  }

  .char-count {
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 12px;
    color: #999;
    pointer-events: none;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.9);
    padding: 0 4px;
  }

  .dialog-footer {
    text-align: center;
    display: flex;
    justify-content: space-between;
    button {
      width: 180px;
    }
  }
}
</style>

